const state = () => ({
  visible: false,
  message: '',
  color: '', // e.g., 'success', 'error', 'info'
  timeout: 6000, // milliseconds
});

const mutations = {
  SHOW_SNACKBAR(state, { message, color, timeout }) {
    state.message = message;
    state.color = color || 'info';
    state.timeout = timeout || 6000;
    state.visible = true;
  },
  HIDE_SNACKBAR(state) {
    state.visible = false;
    // Optional: clear message and color on hide, uncomment if needed
    // state.message = '';
    // state.color = '';
  },
};

const actions = {
  showSnackbar({ commit }, payload) { // payload: { message, color?, timeout? }
    commit('SHOW_SNACKBAR', payload);
  },
  hideSnackbar({ commit }) {
    commit('HIDE_SNACKBAR');
  },
};

const getters = {
  // You can add getters if needed, for example, to get the visibility status
  // isVisible: state => state.visible,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
